import { FSFileList, mapFSFileLists } from "../FileList";
import { FSItem, mapFSItem } from "../Item";
import { FSLocation, mapFSLocation } from "../Location";
import { FSDataOrder, mapFSDataOrder } from "../Order";
import { FSType, mapFSType } from "../Type";

/* **************************************************** Finishing Shedule Light Data */
export interface FSLightData {
    id: number;
    fs_data_id: number;
    item_id: number;
    type_id: number;
    link: string | null;
    number: number | null;
    image_path: string | null;
    file_list: FSFileList[];
    order_status: 'Pending' | 'Ordered' | 'Instore' | 'Onsite';
    order_date_data: string | null;
    order_date: string | null;
    order_data: FSDataOrder | null;
    item: FSItem | null;
    type: FSType | null;
}

export const mapFSLightData = (data: any): FSLightData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSLightData = {
        id: data.id,
        fs_data_id: data.fs_data_id,
        item_id: data.item_id,
        type_id: data.type_id,
        link: data.link || null,
        number: data.number || null,
        image_path: data.image_path || null,
        file_list: Array.isArray(data.file_list) ? mapFSFileLists(data.file_list) : [],
        order_status: data.order_status,
        order_date_data: data.order_date_data || null,
        order_date: data.order_date || null,
        order_data: data.order_data ? mapFSDataOrder(data.order_data) : null,
        item: data.item ? mapFSItem(data.item) : null,
        type: data.type ? mapFSType(data.type) : null,
    };

    return res;
};

export const mapFSLightDatas = (data: any[]): FSLightData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSLightData);
};

/* **************************************************** Finishing Shedule Light */
export interface FSLight {
    id: number;
    fs_feature_id: number;
    category: string | null;
    location_name: string | null;
    location_id: number | null;
    is_default_feature: 1 | 0;
    location: FSLocation | null;
    data_light: FSLightData[];
}

export const mapFSLight = (data: any): FSLight => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSLight = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        category: data.category || null,
        location_name: data.location_name || null,
        location_id: data.location_id || null,
        is_default_feature: data.is_default_feature,
        location: data.location ? mapFSLocation(data.location) : null,
        data_light: Array.isArray(data.data_light) ? mapFSLightDatas(data.data_light) : [],
    };

    return res;
};

export const mapFSLights = (data: any[]): FSLight[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSLight);
};
